import { type HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

interface PageContainerProps extends HTMLAttributes<HTMLDivElement> {
  width?: "wide" | "content";
}

/** max-w-7xl (1280px) for wide, max-w-5xl (1024px) for content */
const widthClasses = {
  wide: "max-w-7xl",
  content: "max-w-5xl",
} as const;

export function PageContainer({
  width = "content",
  className,
  children,
  ...rest
}: PageContainerProps) {
  return (
    <div
      className={cn(
        "mx-auto w-full px-4 md:px-6",
        widthClasses[width],
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
